import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, RevealWords, Overline } from "./shared";

const gallery = [
  {
    src: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    label: "Data Centers",
    tag: "Infrastructure",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    src: "https://images.unsplash.com/photo-1518770660439-4636190af475?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    label: "Hardware & Circuits",
    tag: "Engineering",
    span: "md:col-span-5",
  },
  {
    src: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    label: "Security Operations",
    tag: "Cyber",
    span: "md:col-span-5",
  },
  {
    src: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    label: "Software & Cloud",
    tag: "Development",
    span: "md:col-span-4",
  },
  {
    src: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    label: "Networking",
    tag: "Connectivity",
    span: "md:col-span-4",
  },
  {
    src: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    label: "Consulting & Teams",
    tag: "People",
    span: "md:col-span-4",
  },
];

export default function Showcase() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const yA = useTransform(scrollYProgress, [0, 1], [40, -40]);

  return (
    <section
      ref={ref}
      id="showcase"
      data-testid="showcase-section"
      className="relative mx-auto max-w-7xl px-6 py-16 md:py-24"
    >
      <div className="mb-14 max-w-2xl">
        <Reveal>
          <Overline>In the field</Overline>
        </Reveal>
        <RevealWords
          text="Technology we live and breathe"
          className="font-display mt-5 text-4xl font-semibold leading-tight text-white md:text-5xl"
        />
      </div>

      <div className="grid auto-rows-[220px] grid-cols-1 gap-5 md:grid-cols-12">
        {gallery.map((g, i) => (
          <Reveal key={g.label} delay={i * 0.06} className={g.span}>
            <motion.div
              style={{ y: i % 2 === 0 ? yA : undefined }}
              whileHover={{ scale: 1.01 }}
              data-testid={`showcase-item-${i}`}
              className="group relative h-full w-full overflow-hidden rounded-3xl border border-white/10"
            >
              <img
                src={g.src}
                alt={g.label}
                loading="lazy"
                className="animate-kenburns h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#05050a] via-[#05050a]/25 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-6">
                <span className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[#00f0ff]">
                  {g.tag}
                </span>
                <p className="font-display mt-1 text-xl text-white">{g.label}</p>
              </div>
              <div className="pointer-events-none absolute inset-0 opacity-0 ring-1 ring-inset ring-[#b026ff]/50 transition-opacity duration-500 group-hover:opacity-100" />
            </motion.div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
